interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div className={isCenter ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.28em] uppercase text-primary-600">
        <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>
      ) : null}
    </div>
  );
}